var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareIconPrivacy = function SvgYeswareIconPrivacy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#E7F1FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.692 7.238H10.294A1.283 1.283 0 0 0 9.02 8.52v5.355a15.612 15.612 0 0 0 8.274 13.836.422.422 0 0 0 .401 0 15.616 15.616 0 0 0 8.273-13.835V8.52a1.282 1.282 0 0 0-1.275-1.283Zm-2.153 6.794-6.072 5.73a.856.856 0 0 1-1.197-.02l-2.03-2.05a.855.855 0 1 1 1.216-1.203l1.438 1.454 5.47-5.154a.856.856 0 0 1 1.175 1.243Z",
    fill: "#039BE5"
  })));
};
export default SvgYeswareIconPrivacy;